/**
 * Mutation observer script to intercept and override trustarc inline global tag selectors (a {...} and a:hover {...})
 * See https://auth0team.atlassian.net/browse/DXDP-1478
 */

let trustArcStyleFound = false;
let trustArcMutationObserver;

function onTrustArcMutation(mutations) {
  if (trustArcStyleFound) {
    return;
  }

  try {
    mutations.forEach((m) => {
      if (!trustArcStyleFound) {
        const styleNode = [...m.addedNodes].find(
          (node) =>
            node.nodeName === "STYLE" &&
            node.parentNode &&
            node.parentNode.id === "consent_blackbar"
        );

        if (styleNode) {
          styleNode.innerHTML = styleNode.innerHTML
            .replace(/\}\s?a\s\{/g, "}#consent_blackbar a {")
            .replace(/\}\s?a\:hover\s\{/g, "}#consent_blackbar a:hover {");
          trustArcStyleFound = true;
        }
      }
    });
  } catch {}
}

try {
  trustArcMutationObserver = new MutationObserver(onTrustArcMutation);
  trustArcMutationObserver.observe(document, {
    childList: true,
    subtree: true,
  });
} catch {}
